/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';

import {SUPPRESS_CONFIRM} from '../../constants';
import {enableScroll} from '../../helpers';

import Loader from './../../components/Loader';

import styles from './index.module.css';

export default ({_entityId, voteType, sendVote, setModal}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuppressChecked, setIsSuppressChecked] = useState(true);

  const suppressHandler = () => {
    setIsSuppressChecked(!isSuppressChecked);
  };

  const saveSuppressToLocalstorage = () => {
    localStorage.setItem(SUPPRESS_CONFIRM, isSuppressChecked);
  };

  const handleVote = () => {
    setIsLoading(true);
    saveSuppressToLocalstorage();
    sendVote(voteType, _entityId);
  };

  const handleClose = () => {
    setModal({isOpen: false});
    enableScroll();
  };

  useEffect(() => {
    localStorage.setItem(SUPPRESS_CONFIRM, 'false');
  }, []);

  return (
    <div className={styles.wrapper}>
      <svg width="86" height="87" viewBox="0 0 86 87" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M55.257 7.86684C39.2934 1.92372 20.7102 6.97266 9.92587 20.1346C-0.83264 33.2604 -2.2952 52.2467 6.51464 66.7996C15.2815 81.2888 32.5484 88.8655 49.1572 85.5958C67.9728 81.891 81.579 64.914 81.7209 45.8696C81.5962 29.0471 71.07 13.7553 55.257 7.86684Z" fill="#EFF3FE" />
        <path d="M58.2724 76.5976C43.2554 81.9391 26.1908 77.2854 15.9314 65.1187C5.4784 52.7275 4.11046 34.4779 12.4944 20.6283C20.7965 6.91152 37.2675 -0.339106 52.9943 2.87847C70.7515 6.51196 83.5618 22.4325 83.6951 40.4727C83.5747 56.4896 73.4529 71.196 58.2724 76.5976ZM59.378 2.46988C43.4189 -3.47325 24.8358 1.5757 14.0516 14.7376C3.29315 27.8634 1.83058 46.8498 10.636 61.4026C19.4071 75.8918 36.6739 83.4685 53.2825 80.1989C72.0979 76.4944 85.704 59.5166 85.8459 40.4727C85.7212 23.6502 75.1951 8.35838 59.378 2.46988Z" fill="#1E54B7" />
        <path d="M42.459 39.7243H48.01V59.1528H42.459V39.7243ZM42.459 25.8467H48.01V31.3977H42.459V25.8467Z" fill="#1E54B7" stroke="#EFF3FE" strokeWidth="1.38776" />
      </svg>

      <h4 className={styles.heading}>Вы можете проголосовать один раз «за» и один раз «против» в каждой номинации</h4>
      <p className={styles.text}>Без возможности поменять свой голос</p>
      {isLoading
        ? <div className={styles.loaderWrapper}><Loader fit /></div>
        : (
          <>
            <button className={styles.loginButton} disabled={isLoading} onClick={handleVote}>
              <span className={styles.loginButtonText}>Проголосовать</span>
            </button>
            <button className={styles.cancelButton} onClick={handleClose}>Отмена</button>
          </>
        )
      }

      <div className={styles.suppressCheckbox}>
        <input id='suppress' type="checkbox" onChange={suppressHandler} checked={isSuppressChecked} />
        <label htmlFor="suppress" className={styles.suppressCheckboxLabel}>
          <span className={styles.suppressText}>Больше не показывать это окно</span>
        </label>
      </div>
    </div>
  );
};
